import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({name: 'sanitizeHtml'})
export class HtmlSanitizer implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(value: string | null | undefined): SafeHtml {
    if (!value) return '';

    // DOMPurify config:
    //  - Keeps <style> tags
    //  - Keeps inline style="" attributes
    //  - Removes <script> and dangerous stuff
    const cleanHtml = DOMPurify.sanitize(value, {
      // allow <style> and <mat-icon> tags
      ADD_TAGS: ['style', 'mat-icon'],
      // allow inline style="" and target="" attributes
      ADD_ATTR: ['style', 'target'],
      // explicitly forbid <script>
      FORBID_TAGS: ['script']
      // keep default safe behaviour for everything else
    });

    return this.sanitizer.bypassSecurityTrustHtml(cleanHtml);
  }
}
